import ConnectedEmailOwner from './ConnectedEmailOwner';
export default ConnectedEmailOwner;